import { h, Component } from "preact";
import { Router } from "preact-router";
import { publicPath } from "../config";

import Header from "./header";
// import Footer from './footer';

// Code-splitting is automated for routes
import Home from "../routes/home";
import Profile from "../routes/profile";

export default class App extends Component {
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */

  componentWillMount() {
    try {
      const [, spotId] = /spot_id=(\d+)/.exec(window.location.search);
      window.sessionStorage.setItem("spotId", spotId);
    } catch {}
  }

  handleRoute = (e) => {
    this.currentUrl = e.url;
  };

  render() {
    return (
      <div id="app">
        <Header />
        <Router onChange={this.handleRoute}>
          <Home path={`${publicPath}/`} />
          <Profile path={`${publicPath}/:ticket`} />
        </Router>
        {/* <Footer /> */}
      </div>
    );
  }
}
